import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCalendar = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M3 26h4.5v-4.5H3V26zm5.5 0h5v-4.5h-5V26zM3 20.5h4.5v-5H3v5zm5.5 0h5v-5h-5v5zm-5.5-6h4.5V10H3v4.5zM14.5 26h5v-4.5h-5V26zm-6-11.5h5V10h-5v4.5zm12 11.5H25v-4.5h-4.5V26zm-6-5.5h5v-5h-5v5zM9 7V2.5a.48.48 0 0 0-.148-.352A.48.48 0 0 0 8.5 2h-1a.48.48 0 0 0-.352.148A.48.48 0 0 0 7 2.5V7c0 .135.05.253.148.352A.48.48 0 0 0 7.5 7.5h1a.48.48 0 0 0 .352-.148A.48.48 0 0 0 9 7zm11.5 13.5H25v-5h-4.5v5zm-6-6h5V10h-5v4.5zm6 0H25V10h-4.5v4.5zM21 7V2.5a.48.48 0 0 0-.148-.352A.48.48 0 0 0 20.5 2h-1a.48.48 0 0 0-.352.148A.48.48 0 0 0 19 2.5V7c0 .135.05.253.148.352a.48.48 0 0 0 .352.148h1a.48.48 0 0 0 .352-.148A.48.48 0 0 0 21 7zm6-1v20a1.92 1.92 0 0 1-.594 1.406A1.922 1.922 0 0 1 25 28H3a1.92 1.92 0 0 1-1.406-.594A1.922 1.922 0 0 1 1 26V6c0-.542.198-1.01.594-1.406A1.922 1.922 0 0 1 3 4h2V2.5c0-.688.245-1.276.734-1.766A2.407 2.407 0 0 1 7.5 0h1a2.41 2.41 0 0 1 1.766.734c.49.49.734 1.079.734 1.766V4h6V2.5c0-.688.245-1.276.734-1.766A2.407 2.407 0 0 1 19.5 0h1a2.41 2.41 0 0 1 1.766.734c.49.49.734 1.079.734 1.766V4h2c.542 0 1.01.198 1.406.594.396.396.594.864.594 1.406z" />
  </svg>
);
export default SvgCalendar;
